import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UiStoreService {

  isMobile: boolean = true;
  expandedArtifactId: BehaviorSubject<string> = new BehaviorSubject('');
  selectedTab:any = {
    appWizard : 1
  };

  leftMenuRef: MatSidenav | undefined;
  constructor() { }

  
}
